import request from '@/utils/request'

// 获取料价汇率
export function getRate() {
  return request({
    url: 'business/rate/my-rate',
    method: 'get',
  })
}

// 保存料价汇率
export function saveRate(data) {
  return request({
    url: `business/rate/edit/${data.id}`,
    method: 'post',
    data
  })
}

// 折扣调节功能
export function editDiscount(data) {
  return request({
    url: `business/rate/edit-discount`,
    method: 'post',
    data
  })
}
